module.exports = __webpack_public_path__ + "img/lunbo131.49bb70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo131.png
// module id = nXVb
// module chunks = 0